import { render, staticRenderFns } from "./NoticeBids.vue?vue&type=template&id=1c763bb6&"
import script from "./NoticeBids.vue?vue&type=script&lang=js&"
export * from "./NoticeBids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports